module.exports = __webpack_public_path__ + "ac6371ec1c056796138ff897e9c30809.MP3";